import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerIconAndTextConverter extends CmsConverterService<CongressContainerIconAndTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      icon: formData.st_icon?.value?.identifier ?? '',
      text: formData.st_text ?? defaultTextInput
    }
  }
}

export const CONGRESS_CONTAINER_ICON_AND_TEXT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CongressContainerIconAndTextData>>('CongressContainerIconAndTextConverter')

export interface CongressContainerIconAndTextData extends ConvertedComponentData {
  icon: string;
  text: TextInput;
}
